export { CollectiblePurchasePromo } from './CollectiblePurchasePromo'
